import { render, staticRenderFns } from "./JAVideo.vue?vue&type=template&id=c86cb0ce&scoped=true&"
import script from "./JAVideo.vue?vue&type=script&lang=js&"
export * from "./JAVideo.vue?vue&type=script&lang=js&"
import style0 from "./JAVideo.vue?vue&type=style&index=0&id=c86cb0ce&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86cb0ce",
  null
  
)

export default component.exports